import React, { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { LoadingStates, ScriptPathTypesV2, ScriptPathV2 } from 'typings';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

interface ScriptStepAnswerProps {
  initialOtherValue: string | null;
  onOtherChange: Function;
  scriptPath: ScriptPathV2;
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(0.5),
  },
  otherTextField: {
    width: '80%',
  },
  otherTextInput: {
    fontSize: '0.875rem',
    textAlign: 'center',
  },
  value: {
    fontStyle: 'italic',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    whiteSpace: 'pre-wrap',
  },
}));

const ScriptStepAnswer = ({
  initialOtherValue,
  onOtherChange,
  scriptPath,
}: ScriptStepAnswerProps) => {
  const styles = useStyles();

  const isLoading = useSelector(
    (state: RootState) => state.script.loadingState === LoadingStates.LOADING
  );
  const [otherValue, setOtherValue] = useState(initialOtherValue);
  const isOtherSelected = scriptPath.type === ScriptPathTypesV2.OTHER;

  return (
    <div className={styles.container}>
      <div className={styles.label}>{scriptPath.label}</div>
      {isOtherSelected && !initialOtherValue && (
        <TextField
          multiline
          value={otherValue}
          disabled={isLoading}
          onChange={(event) => setOtherValue(event?.target.value)}
          onBlur={(event) => onOtherChange(event.target.value)}
          placeholder="-"
          className={styles.otherTextField}
          inputProps={{
            className: styles.otherTextInput,
          }}
        />
      )}
      {isOtherSelected && !!initialOtherValue && <div className={styles.value}>{otherValue}</div>}
    </div>
  );
};

export default ScriptStepAnswer;
